import SparklesIcon from "@heroicons/react/24/outline/SparklesIcon";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../../assets/colors";
import SpeechTailSVG from "../../../../assets/svg/speech-tail.svg";

// Icon Component //
export const SparklesIconStyled = styling(SparklesIcon)({
  width: "1rem",
  height: "1rem",
});

export const AiSummaryContainer = styling(Box)((props) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  borderRadius: "10px",
  padding: "0.75rem",
  border: `1.5px solid ${Color.grey}`,
  backgroundColor: "#F7F7FF",
  width: "100%",
}));

export const AiSummaryTextContainer = styling(Box)((props) => ({
  position: "relative",
  backgroundColor: Color.white,
  border: `1.5px solid ${Color.grey}`,
  borderRadius: "0px 8px 8px 8px",
  padding: "1rem",
  height: "100%",
}));

export const AiSummaryTitleContainer = styling(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
});

export const AiSummaryTitle = styling(Box)((props) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
}));

// Image Component //
export const AshleyImage = styling("img")({
  border: `2px solid ${Color.black}`,
  borderRadius: "50%",
});

export const SpeechTail = styling(SpeechTailSVG)({
  position: "absolute",
  left: "0",
  top: "0",
  transform: "translate(-1.75px, -12.8px)",
});

export const AiSummaryTitleText = styling(Typography)({
  fontWeight: "600",
  fontSize: "1rem",
  lineHeight: "1.5rem",
  width: "100%",
});

export const AiSummaryText = styling(Typography)((props) => ({
  fontWeight: "400",
  fontSize: "1rem",
  lineHeight: "1.5rem",

  "@media (max-width: 1280px)": {
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  },
}));

export const BetaText = styling(Typography)((props) => ({
  display: "inline-block",
  transform: "translateY(-8px)",
  fontWeight: "700",
  fontSize: "0.625rem",
  letterSpacing: "1px",
  textTransform: "uppercase",
  color: Color.blue,
}));
